import axios from 'axios'
// import Cookies from 'js-cookie'
import router from "../router"

// import $ from 'jquery'


import {
  Loading,
  Message,
  Notification
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
/***
 * @api文档地址
 * https://documenter.getpostman.com/view/9459507/TzsWtqF5#http19216801078082
 * http://192.168.0.107:8082
 *
 */

const http = axios.create({
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  baseURL: process.env.API_ROOT,
  timeout: 120000
})


// let loading;
// let loadingNum = 0;
// function startLoading() {
//     if (loadingNum == 0) {
//         loading = Loading.service({
//             lock: true,
//             text: 'loading...',
//             background: 'rgba(0,0,0,0.8)',
//         })
//     }
//     //请求数量加1
//     loadingNum++;
// }
// function endLoading() {
//     //请求数量减1
//     loadingNum--
//     if (loadingNum <= 0) {
//         loading.close();
//     }
// }


let language
http.interceptors.request.use(config => {
  // startLoading();
  if (config.method == "post") {

  }

  // config.headers.authorization = "Bearer" + " " + localStorage.access_token;
  config.headers.authorization = "Bearer" + " " + localStorage.getItem('access_token')

  return config

}, err => {

  return Promise.reject(err);

})



http.interceptors.response.use(res => {
  // endLoading()

  if (res.status == 200) {
    let status = res.data.meta.status;
    // console.log(status);
    switch (status) {
      case 10400:
        Message.error("非法请求");

        router.push("/stuLogin");
        break;
      case 10401:
        Message.error("未验证");

        router.push("/stuLogin");
        break;
      case 10403:
        Message.error("无权限");

        router.push("/stuLogin");
        break;
      case 10404:
        Message.error("未找到资源");

        router.push("/stuLogin");
        break;
      case 10500:
        Message.error("服务器错误");

        router.push("/stuLogin");
        break;
      case 10001:
        Message.error("未登录");

        router.push("/stuLogin");
        break;
      case 10010:
        Message.error("已存在的账户");

        router.push("/stuLogin");
        break;
      case 10011:
        Message.error("不存在的账户");

        router.push("/stuLogin");
        break;
      case 20000:
        Message.error("无效的客户端");

        router.push("/stuLogin");
        break;
      case 20002:
        Message.error("登陆已过期");

        router.push("/stuLogin");
        break;
      case 20002:
        Message.error("登陆已过期");

        router.push("/stuLogin");
        break;


      case 20003:
        if (language === "en") {
          Message.warning("Invalid CAPTCHA");
        } else {
          Message.error("无效的验证码");
        }

        break;
      case 20005:
        // Message.error("未找到排考数据");

        // router.push("/stuLogin");
        break;
      case 20006:

        if (language === "en") {
          Message.warning("Login expired");
        } else {
          Message.error("登录已过期");
        }

        router.push("/stuLogin");
        break;
      case 20007:
        // Message.error("已交卷");

        // router.push("/workSearch/myWork");
        break;
      case 20008:
        if (language === "en") {
          // Message.warning("Data under review");
        } else {
          // Message.error("考试已结束");
          router.push("/endWork");
        }

        break;
      case 20100:
        if (language === "en") {
          Message.warning("Invalid user name or password");
        } else {
          Message.error("无效的用户名或密码");
        }

        // router.push("/stuLogin");
        break;

      case 20101:
        Message.error("无效的密码");
        // router.push("/stuLogin");
        break;
      case 20102:
        Message.error("学号已存在");

        router.push("/stuLogin");
        break;
      case 20201:
        Message.error("上传失败");

        break;
      case 20202:
        Message.error("导入失败");

        break;
      case 20203:
        Message.error("添加失败");

        break;
      case 20204:
        Message.error("修改失败");

        break;
      case 20205:
        Message.error("保存失败，考试已结束");
        router.push("/endWork");
        break;
      case 29999:
        Message.error("未知错误");

        break;
      default:
        break;
    }
    return Promise.resolve(res.data);
  }

  // if (res.data.meta.status == 10000) {
  //     return res.data
  // } else {

  //     Promise.reject(res);

  //     Notification.error({
  //         title: "错误",
  //         message: res.data.meta.status + res.data.data,
  //     })
  // }

}, err => {
  return Promise.reject(err);
})

export default http



// WEBPACK FOOTER //
// ./src/http/request.js